import { render, staticRenderFns } from "./POIOverview.vue?vue&type=template&id=0c5c7de9"
import script from "./POIOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./POIOverview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports